module.exports = __webpack_public_path__ + "img/align-1--active.8a95defd.svg";